import React from 'react';
import styles from './SpectacularPortrait.module.css';
import BasePanel from '../BasePanel/BasePanel.jsx';

const spectacularPortraitImg = require('../../../../images/Illustration_Play_Spectacular_portrait.png');
const spectacularPortraitCanNotLoadImg = require('../../../../images/adshel_can_not_load_adcopy.png');

const SpectacularPortrait = ({ mediaArray, videoAutoPlayInterval }) => {

    return (
        <BasePanel
            mediaArray={mediaArray}
            backgroundImage={spectacularPortraitImg}
            cannotLoadImage={spectacularPortraitCanNotLoadImg}
            customStyles={styles}
            videoAutoPlayInterval={videoAutoPlayInterval}
        />
    );
};

export default SpectacularPortrait;